import React from 'react'

import {toggleDropdown} from '../modules/functions.js'

const e = React.createElement;


function Labels(props) {
  React.Component.constructor.call(this);

  this.state = {dropdown_open:false};

  this.handleClickOutside = this.handleClickOutside.bind(this);
}
Labels.prototype = Object.create(React.Component.prototype);

Labels.prototype.componentDidMount = function() {
  document.addEventListener('mousedown', this.handleClickOutside);
}

Labels.prototype.componentWillUnmount = function() {
  document.removeEventListener('mousedown', this.handleClickOutside);
}

Labels.prototype.setWrapperRef = function(node) {
  this.wrapperRef = node;
}

Labels.prototype.handleClickOutside = function(e) {
  if(this.wrapperRef && !this.wrapperRef.contains(e.target)) {
    this.setState({dropdown_open:false});
  }
}

Labels.prototype.render = function() {
  const label_list = this.props.label_list;
  const item_labels = this.props.item_labels;
  const displayMode = this.props.displayMode;
  
  if(label_list && label_list.isValid) {
    var labels = null, label_picker = null, labels_linked = [], labels_notlinked = [];
    if(!displayMode) {
      if(item_labels) {
        var item_labels_array = item_labels.split(";;");
        var labels_without_date = item_labels_array.map(function(label) {
          return label.split(",")[0];
        });
        labels_linked = label_list.data.filter(function(label) {
          return labels_without_date.indexOf(""+label.id) > -1;
        });
        labels_notlinked = label_list.data.filter(function(label) {
          return labels_without_date.indexOf(""+label.id) === -1;
        });

        if(labels_linked.length > 0) {
          labels = labels_linked.map(function(label, i) {
            return e('span', {key:"1_"+i+"_"+label.id, onClick:this.handleRemoveLabel.bind(this, label.id), style:{background:"#"+label.background, color:"#"+label.color}}, label.name);
          }.bind(this));
        }
      } else {
        labels_notlinked = label_list.data;
      }
      if(labels_notlinked.length > 0) {
        var available_labels = labels_notlinked.map(function(label, i) {
          return e('li', {key:"2_"+i+"_"+label.id, onClick:this.handleAddLabel.bind(this, label.id), className:"sub-item"}, e('div', {className:"c"}, e('span', {style:{background:"#"+label.background, color:"#"+label.color}}, label.name)));
        }.bind(this));

        label_picker = e('div', {key:"dd", className:"dropdown" + (this.state.dropdown_open ? " open" : ""), ref:this.setWrapperRef.bind(this)}, [
          e('span', {key:"dt", className:"dropdown-toggle", onClick:toggleDropdown.bind(null, this)}, "+"),
          e('div', {key:"dm", className:"dropdown-menu right"}, [
            e('div', {key:"dc", className:"dropdown-caret"}, [
              e('i', {key:"io", className:"caret-outer"}),
              e('i', {key:"ii", className:"caret-inner"})
            ]),
            e('ul', {key:"al"}, available_labels)
          ])
        ]);
      }
    } else if(displayMode && item_labels) {
      var item_labels_array = item_labels.split(";;");
      labels = item_labels_array.map(function(item_label, i) {
        var item_label_id = item_label.split(",")[0];
        var item_label_cd = item_label.split(",")[1];
        var label = label_list.data.filter(function(label) {
          return item_label_id === ""+label.id;
        })[0];
        var label_name = label.name;
        if(item_label_cd) label_name = label.name+" "+item_label_cd;
        return e('span', {key:"3_"+i+"_"+label.id, style:{background:"#"+label.background, color:"#"+label.color}}, label_name);
      });
    }
    if(labels && label_picker) {
      return e('div', {className:"contact-labels" + (!displayMode ? " editmode" : "")}, [labels, label_picker]);
    } else if(labels) {
      return e('div', {className:"contact-labels" + (!displayMode ? " editmode" : "")}, labels);
    } else if(label_picker) {
      return e('div', {className:"contact-labels" + (!displayMode ? " editmode" : "")}, label_picker);
    } else {
      return null;
    }
  } else {
    return null;
  }
}

Labels.prototype.handleAddLabel = function(label_id) {
  var new_item_labels = "";

  if(this.props.item_labels === "" || this.props.item_labels === undefined) {
    new_item_labels = ""+label_id;
  } else {
    new_item_labels = this.props.item_labels + ";;" + label_id;
  }

  this.props.updateLabels(this.props.item_labels_sn, new_item_labels);
}

Labels.prototype.handleRemoveLabel = function(label_id) {
  var new_item_labels = "";
  new_item_labels = this.props.item_labels.split(";;").filter(function(_label) {
    return _label.split(",")[0] !== ""+label_id;
  }).join(';;');

  this.props.updateLabels(this.props.item_labels_sn, new_item_labels);
}


export default Labels



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Labels.js
// module id = 232
// module chunks = 0